<template>
  <!-- 党史人物详情页 -->
  <div>
    <div class="dsxxpage-content">
      <!--面包屑-->
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>党史学习</el-breadcrumb-item>
          <el-breadcrumb-item>党史人物</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $route.params.type }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ leaderList[$route.params.activeName][$route.params.index].name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="dsxqy-cont">
        <div class="dsxqy-cont-up">
          <div><img width="180" height="180" :src="leaderList[$route.params.activeName][$route.params.index].src" /></div>
          <div class="dsxqy-rwjj">
            <h5>{{ leaderList[$route.params.activeName][$route.params.index].name }}</h5>
            <el-scrollbar style="height: 150px;">
              <div class="brief">
                <p>{{ leaderList[$route.params.activeName][$route.params.index].brief }}</p>
                <p class="dsxqy-rwxb" v-if="$route.params.activeName==0">{{ leaderList[$route.params.activeName][$route.params.index].source }}</p>
              </div>
            </el-scrollbar>
          </div>
        </div>
        <div class="dsxqy-cont-down" v-loading="loading">
          <el-empty description="暂无内容" v-if="!loading && !dnhdList.length"></el-empty>
          <ul v-else>
            <li v-for="(item, index) in dnhdList" :key="index">
              <a :href="item.nodeUrl" target="_blank">{{ item.title }}</a>
              <span>{{ item.time }}</span>
            </li>
            <p>
              <a v-if="!loading && dnhdList.length && total>10" :href="`/#/more/${$route.params.uid}/${breadcrumb}`" target="_blank">查看更多>></a>
            </p>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin } from "../mixins/mixin";
export default {
  mixins: [mixin],
  data() {
    return {
      list: [{}],
      dnhdList: [],
      loading:true,
      total:0,
      breadcrumb:''
    };
  },
  mounted(){
    this.getList()
  },
  methods:{
    getList(){
      this.axios.post(`data/cnki/getKbaseList`,{
        uid: this.$route.params.uid,
        pageNum: 1,
        pageSize: 10,
        sign:'更多'
      }).then((res) => {
          if (res.status == 200) {
            if(!res.data) return
            this.total = res.data.total
            this.dnhdList = res.data.rows;
            this.loading = false
            this.breadcrumb = `党史学习>党史人物>${this.$route.params.type}>${this.leaderList[this.$route.params.activeName][this.$route.params.index].name}`
          } else {
            this.$message.error("获取失败！");
          }
        });
    }
  }
};
</script>

<style  lang="scss" scoped>
.dsxxpage-content {
  width: 1200px;
  height: auto;
  margin: 30px auto;
  margin-bottom: 70px;
  .breadcrumb {
    position: relative;
    box-sizing: border-box;
    padding-left: 20px;
    .el-breadcrumb {
      font-size: 16px;
    }
  }
  .breadcrumb:before {
    content: "";
    position: absolute;
    left: 0;
    display: inline-block;
    width: 17px;
    height: 16px;
    background: url("../assets/images/dzdgpage_arr.png") no-repeat;
  }
  .dsxxpage-cont {
    position: relative;
    height: auto;
    margin-top: 20px;
  }
  .dsxqy-cont {
    .dsxqy-cont-up {
      height: 260px;
      margin-top: 20px;
      display: flex;
      box-sizing: border-box;
      padding: 35px 90px 0 95px;
      background: url("../assets/images/dsxqy-upbg.png") no-repeat;
      .dsxqy-rwjj {
        margin-left: 55px;
        h5 {
          text-align: center;
          font-size: 20px;
          color: #383636;
          margin-bottom: 15px;
        }
        p {
          font-size: 16px;
          color: #383636;
          line-height: 24px;
          font-weight: 500;
          text-indent: 30px;
        }
        .brief{
          margin-right: 20px;
        }
        .dsxqy-rwxb {
          text-align: right;
          color: #383636;
          margin-top: 15px;
        }
      }
    }
    .dsxqy-cont-down {
      width: 1200px;
      height: 416px;
      margin-top: 15px;
      box-sizing: border-box;
      padding: 16px 30px 0 30px;
      background: url("../assets/images/dnhd-dwbg.png") repeat-x;
      li {
        position: relative;
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        line-height: 40px;
        a {
          margin-left: 18px;
        }
      }
      li:before {
        position: absolute;
        top: 14px;
        content: "";
        display: inline-block;
        width: 8px;
        height: 12px;
        background: url("../assets/images/vector.png") no-repeat;
      }
      p {
        text-align: right;
        font-size: 16px;
        margin-top: 10px;
        a {
          color: #9f9fa6;
        }
      }
    }
  }
}
</style>